import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SlackPushPayload, SlackPushResponse } from '@notifications/entities/slack-push';
import { SlackPushService } from '@notifications/slack/services/slack-push.service';

@Injectable()
export class PushService {

  constructor(
    private slackPushService: SlackPushService) { }

  public sendSlackPushNotification(payload: SlackPushPayload): Observable<SlackPushResponse> {
    return this.slackPushService.sendSlackPushNotification(payload);
  }
}
